import React from 'react';
import { useRecoilValue } from 'recoil';
import { abTestState } from '../../recoil/atoms';
import { Button } from '../../root/components/buttons/Button';
import { assetPathFn } from '../../util';
import styles from './ProductComparison.module.scss';

export const ProductComparison: React.FC<{
  title: string | React.ReactNode;
  description?: string;
  competitorText: string;
  honeyloveText: string;
  competitorImage: string;
  honeyloveImage: string;
  onCtaClick: () => void;
}> = ({ title, competitorImage, honeyloveImage, honeyloveText, competitorText, description, onCtaClick }) => {
  const abTests = useRecoilValue(abTestState);

  return (
    <div className={styles.productComparisonWrapper}>
      <div>
        <div className={styles.productComparisonTitle}>{title}</div>
        {description && <div className={styles.description}>{description}</div>}
        {!abTests['AB2022-02'] && <Button text="Shop now" onClick={onCtaClick} buttonType="transparent" size="large" />}
      </div>
      <div className={styles.productComparison}>
        <div>
          <div>Competitor</div>
          <img src={assetPathFn(competitorImage)} alt={competitorText} />
        </div>
        <div>
          <div>{honeyloveText}</div>
          <img src={assetPathFn(honeyloveImage)} alt={honeyloveText} />
        </div>
      </div>
    </div>
  );
};

export default ProductComparison;
